export const HEADER_HEIGHT = 56
export const LANDING_FOOTER_HEIGHT = 40
